import { injectable } from 'tsyringe';
import { BaseViewModel } from '@/shared/viewmodels/BaseViewModel';
import { ClassificationService } from './ClassificationService';

/**
 * Backs the subdued "Classifications" card shown on each analytics surface.
 * Loads the count of classifications in the card's category to drive its badge.
 */
@injectable()
export class ClassificationSurfaceCardViewModel extends BaseViewModel {
    count = 0;
    loaded = false;

    constructor(private readonly service: ClassificationService) {
        super();
    }

    async initialize(category: string): Promise<void> {
        try {
            const all = await this.service.list();
            this.count = all.filter((c) => c.category === category).length;
        } catch {
            this.count = 0;
        } finally {
            this.loaded = true;
            this.notifyChange();
        }
    }
}
